if (!window.collectionVariantPopupInitialized) {
  window.collectionVariantPopupInitialized = true;

  document.addEventListener("DOMContentLoaded", () => {
    const popup = document.getElementById("collectionVariantPopup");
    if (!popup) {
      return;
    }

    const image = document.getElementById("collectionVariantPopupImage");
    const title = document.getElementById("collectionVariantPopupTitle");
    const price = document.getElementById("collectionVariantPopupPrice");
    const variantSelect = document.getElementById("collectionVariantPopupVariant");
    const variantList = document.getElementById("collectionVariantPopupVariantList");
    const qtyInput = document.getElementById("collectionVariantPopupQty");
    const submitButton = document.getElementById("collectionVariantPopupSubmit");
    const message = document.getElementById("collectionVariantPopupMessage");

    function formatMoneyFromCents(cents) {
      return `£${(Number(cents) / 100).toFixed(2)}`;
    }

    function openPopup(productData) {
      title.textContent = productData.title || "";
      price.textContent = formatMoneyFromCents(productData.price_min || 0);

      image.src = productData.image || "";
      image.alt = productData.title || "";

      qtyInput.value = 1;
      message.textContent = "";
      submitButton.disabled = false;



variantList.innerHTML = "";
variantSelect.value = "";

productData.variants.forEach((variant, index) => {
  const button = document.createElement("button");
  button.type = "button";
  button.className = "collection-variant-popup__variant-btn";
  button.textContent = variant.title;
  button.dataset.variantId = String(variant.id);
  button.dataset.price = String(variant.price);
  button.disabled = !variant.available;

  if (!variant.available) {
    button.classList.add("is-soldout");
  }

  button.addEventListener("click", () => {
    if (button.disabled) {
      return;
    }

    variantList.querySelectorAll(".collection-variant-popup__variant-btn").forEach((item) => {
      item.classList.remove("is-active");
    });

    button.classList.add("is-active");
    variantSelect.value = String(variant.id);
    price.textContent = formatMoneyFromCents(variant.price);
    submitButton.disabled = false;
    message.textContent = "";
  });

  variantList.appendChild(button);
});

const firstAvailable = productData.variants.find((variant) => variant.available);
if (firstAvailable) {
  variantSelect.value = String(firstAvailable.id);
  price.textContent = formatMoneyFromCents(firstAvailable.price);

  const firstAvailableButton = variantList.querySelector(
    `[data-variant-id="${String(firstAvailable.id)}"]`
  );

  if (firstAvailableButton) {
    firstAvailableButton.classList.add("is-active");
  }

  submitButton.disabled = false;
} else {
  submitButton.disabled = true;
}


      popup.hidden = false;
      document.body.classList.add("collection-variant-popup-open");
    }

    function closePopup() {
      popup.hidden = true;
      document.body.classList.remove("collection-variant-popup-open");
      message.textContent = "";
      submitButton.disabled = false;
    }

    async function addToCart() {
      const variantId = variantSelect.value;
      const quantity = Number(qtyInput.value) || 1;

      if (!variantId || quantity < 1) {
        message.textContent = "Please choose a valid quantity.";
        return;
      }

      submitButton.disabled = true;
      message.textContent = "Adding to cart...";

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: quantity
          })
        });

        if (!response.ok) {
          throw new Error("Add to cart request failed.");
        }

        await response.json();

        message.textContent = "Added to cart.";

        setTimeout(() => {
          window.location.href = "/cart";
        }, 500);
      } catch (error) {
        message.textContent = "Could not add this item to cart.";
        submitButton.disabled = false;
      }
    }

    document.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-variant-popup-trigger]");
      if (trigger) {
        event.preventDefault();

        const rawProduct = trigger.getAttribute("data-product-json");
        if (!rawProduct) {
          return;
        }

        try {
          const productData = JSON.parse(rawProduct);
          openPopup(productData);
        } catch (error) {
          console.error("Invalid product JSON for popup.", error);
        }

        return;
      }

      if (event.target.closest("[data-popup-close]")) {
        closePopup();
      }
    });



    popup.querySelectorAll("[data-qty-action]").forEach((button) => {
      button.addEventListener("click", () => {
        const action = button.getAttribute("data-qty-action");
        const currentValue = Number(qtyInput.value) || 1;

        if (action === "minus" && currentValue > 1) {
          qtyInput.value = currentValue - 1;
        }

        if (action === "plus") {
          qtyInput.value = currentValue + 1;
        }
      });
    });

    submitButton.addEventListener("click", addToCart);

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && !popup.hidden) {
        closePopup();
      }
    });
  });
}